import { useEffect, useState } from 'react';
import { ColaboradoresApi } from '../api/client.js';
import { useAuth } from '../context/AuthContext.jsx';

// Assume que colaborador possui relacionamento com usuario; tenta localizar colaborador cujo usuario_id = auth.usuario.id
export function useDefaultColaborador() {
  const { auth } = useAuth();
  const perfil = String(auth?.usuario?.perfil || '').trim().toUpperCase();
  const colaboradorFromAuth =
    auth?.usuario?.colaboradorId || auth?.usuario?.colaborador_id || '';
  const [colaboradorId,setColaboradorId] = useState(()=> localStorage.getItem('defaultColaboradorId') || '');
  useEffect(()=>{
    if (!auth?.usuario?.id) return;
    if (colaboradorId) return; // já setado
    if (colaboradorFromAuth) {
      setColaboradorId(colaboradorFromAuth);
      localStorage.setItem('defaultColaboradorId', colaboradorFromAuth);
      return;
    }
    if (perfil === 'COLABORADOR') {
      ColaboradoresApi.me().then(resp => {
        const col = resp?.data || resp || null;
        if (col?.id) {
          setColaboradorId(col.id);
          localStorage.setItem('defaultColaboradorId', col.id);
        }
      }).catch(()=>{});
      return;
    }
    ColaboradoresApi.listar().then(resp => {
      const lista = resp?.data || resp || [];
      const found = lista.find(c => c.usuario?.id === auth.usuario.id);
      if (found) {
        setColaboradorId(found.id);
        localStorage.setItem('defaultColaboradorId', found.id);
      }
    }).catch(()=>{});
  }, [auth, colaboradorId, colaboradorFromAuth, perfil]);
  const update = (id) => { setColaboradorId(id); localStorage.setItem('defaultColaboradorId', id || ''); };
  return { colaboradorId, setColaboradorId: update };
}
